import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '@chakra-ui/icons';
export const CancelIcon = ({ isError, fillColor }) => createIcon({
    displayName: 'CancelIcon',
    viewBox: '0 0 18 18',
    path: (_jsx("path", { d: "M1.53337 17.1334L0.866699 16.4667L8.33337 9.00003L0.866699 1.53337L1.53337 0.866699L9.00003 8.33337L16.4667 0.866699L17.1334 1.53337L9.6667 9.00003L17.1334 16.4667L16.4667 17.1334L9.00003 9.6667L1.53337 17.1334Z", fill: isError ? '#AC0000' : fillColor !== null && fillColor !== void 0 ? fillColor : "text" })),
});
//# sourceMappingURL=CancelIcon.js.map